export default __webpack_public_path__ + "static/media/promo-shopping.ebfc87bb.jpg";